import { validateValue } from '../validators/base-validator';
import { USER_PROFILE_VALUE_LENGTH_MAX } from '../constants';
import { outputErrorMessage } from './error-message';
import { errorTypes } from '../validators/error-types';

// regex taken from email-validator ref. https://github.com/manishsaraan/email-validator/blob/master/index.js#L3
const emailRegex =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
const validPrefectures = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
];

export const StandardUserProfile = {
  validateGender(value: string): boolean {
    if (!(value === 'male' || value === 'female' || value === 'other')) {
      outputErrorMessage(errorTypes.CUSTOM, 'Gender', {
        custom: `${value} is an invalid gender. Please select from 'male', 'female' or 'other'`,
      });
      return false;
    }
    return true;
  },

  validateEmail(value: string): boolean {
    if (!emailRegex.test(String(value).toLowerCase())) {
      outputErrorMessage(errorTypes.CUSTOM, 'Email', {
        custom: `${value} is not a valid email address`,
      });
      return false;
    }

    const [result, error] = validateValue(value, {
      type: 'string',
      maxStringLength: USER_PROFILE_VALUE_LENGTH_MAX,
    });
    if (!result) {
      outputErrorMessage(error, 'Email', {
        subject: `value "${value}"`,
        maxStringLength: USER_PROFILE_VALUE_LENGTH_MAX,
      });
      return false;
    }
    return true;
  },

  validatePrefecture(value: string): boolean {
    if (!validPrefectures.includes(value)) {
      outputErrorMessage(errorTypes.CUSTOM, 'Prefecture', {
        custom: `${value} is not a valid prefecture name`,
      });
      return false;
    }
    return true;
  },
};
